<vi-tabs [tabs]="tabs" (select)="onTimeRangeChange($event.value)"></vi-tabs>
<ng-container [ngSwitch]="activeTab">
  <ng-container *ngIf="activeTab !== timeRangeTabNameEnum.days && energyStore.loading$ | async">
    <vi-loader [isLoading]="true" message="{{ '+GENERAL.LOADING_DATA' | translate }}"></vi-loader>
  </ng-container>
  <ng-container *ngIf="activeTab === timeRangeTabNameEnum.days || !(energyStore.loading$ | async)">
    <app-chart-active-bar-summary [activeBar]="activeBar"></app-chart-active-bar-summary>
    <ng-container *ngFor="let period of chartData.periods">
      <div
        class="flex flex-column justify-around items-start no-data-padding"
        *ngIf="period.isChartDataNotAvaiable && period.periodDesignationKey === activeTab"
      >
        {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.NO_GTS_DATA_BOX.TITLE' | translate }}
      </div>
      <ng-container *ngSwitchCase="period.periodDesignationKey">
        <div class="chart-padding flex flex-row justify-start items-end overflow-x-auto">
          <ng-container
            *ngFor="
              let chartBar of period.chartBars.slice().reverse();
              let index = index;
              let last = last
            "
          >
            <div
              class="bar-cursor-pointer flex flex-col justify-center items-center"
              [class.bar-state-active]="activeBarIndex === index"
              [ngStyle]="getBarWidth(period.chartBars.length)"
              gtm="onSelect"
              gtmAction="Active chart bar"
              gtmCategory="consumptionChart"
              (click)="setActiveBar(chartBar, index)"
            >
              <app-chart-bar
                class="bar-width"
                [barModel]="chartBar"
                [hideDesignationKey]="hideBarLabel(index, period.chartBars.length)"
                [selectedRangeMaxValue]="period.maxValueOfThePeriod"
              ></app-chart-bar>
              <app-chart-bar-description
                class="chart-bar-description bar-width"
                [alignNumbers]="alignNumbers"
                [barParts]="filterBarParts(chartBar.chartBarParts)"
              ></app-chart-bar-description>
            </div>
          </ng-container>
        </div>
        <app-period-summary
          [periodName]="period.periodDesignationKey"
          [periodSingularName]="period.periodDesignationKeySingular"
          [seriesSummary]="period.periodSummary"
          [amountOfTheValuesWithinThePeriod]="period.chartBars.length - 1"
        ></app-period-summary>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
